import { AnyObject } from '../types/types';

export const OrderPrintState: AnyObject = {
  1: 'Printed',
  2: 'Not printed'
};
